import React from "react";
import { useQuery } from "react-query";
// import ServiceImage from "@components/common/ddr/ServiceImage";
// import { ServiceType } from "@components/common/ddr/ddrTypes";
import CustomWidget from "@components/common/Widget";
import DonutChart from "@components/common/charts/DonutChart";
import DonutChartLoader from "@components/loaders/DonutChartLoader";
import CategoryDataDialog from "./CategoryDataDialog";
import {
  //  dataClassification,
  dataClassificationSummary,
} from "@services/api/ddrCommonApis";
import NoData from "@components/common/NoDataLabel";

function SensitivityDataByCategory({
  username,
  is_external,
}: {
  username?: string;
  is_external?: boolean;
}) {
  const { data: sensitiveData, isLoading } = useQuery<{
    [key: string]: number;
  }>(["sensitiveData", username], () =>
    dataClassificationSummary({
      classification: "sensitivity",
      source_service: "",
      type: "",
      username: username || "",
      is_external: is_external ? 1 : 0,
    }),
  );
  // const { data: sensitiveData, isLoading } = useQuery<{
  //   [key: string]: number;
  // }>(["sensitiveData"], () =>
  //   dataClassification({
  //     classification: "sensitivity",
  //     source_service: "",
  //     username: username,
  //   }),
  // );

  const sensitivity_based_data = [];
  if (sensitiveData) {
    for (const [key, value] of Object.entries(sensitiveData)) {
      if (key === "pci") {
        sensitivity_based_data.push({ label: "PCI", value: value });
      } else if (key === "phi") {
        sensitivity_based_data.push({ label: "PHI", value: value });
      } else if (key === "pii") {
        sensitivity_based_data.push({ label: "PII", value: value });
      }
    }
  }

  const [selectedCategory, setSelectedCategory] = React.useState("");

  const category_based_popup = (e: string) => {
    setSelectedCategory(e);
  };

  return (
    <>
      <CustomWidget
        title="Categories of Sensitive Records"
        info="Shows the total number of sensitive values detected, grouped by sensitivity type. Note: since a single file can contain multiple sensitive values, the total count may exceed the number of files."
        className="h-full"
      >
        <div
          id="sensitivity_based_donut"
          className="h-full w-full min-h-64 relative"
        >
          {isLoading ? (
            <DonutChartLoader />
          ) : sensitivity_based_data.length == 0 ||
            (sensitivity_based_data.length > 0 &&
              sensitivity_based_data.every((d) => d.value == 0)) ? (
            <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
              <NoData />
            </div>
          ) : (
            <DonutChart
              parentid="sensitivity_based_donut"
              data={sensitivity_based_data}
              handleClick={(e: string) => category_based_popup(e)}
              groupSmall={false}
            />
          )}
        </div>
      </CustomWidget>

      {selectedCategory && (
        <CategoryDataDialog
          selectedDomain={selectedCategory}
          open={true}
          onClose={() => setSelectedCategory("")}
          classification="sensitivity"
          user={username}
          isExternal={is_external ? 1 : 0}
        />
      )}
    </>
  );
}

export default SensitivityDataByCategory;
